import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import { ThemeContext } from "./ThemeContext";
import { SidebarMenu } from "./SidebarMenu";
import img_profil from "../assets/Images/Logo_entreprise.webp";
import "../../Styles/AdminDashbord/sidebar.css";
import { DashboardLayoutContext } from "../../Routes/DashboardLayoutContext";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useAdminAuth } from "./AdminAuthContext";
import { getPermissionForRoute } from "./PermissionsConfig";
import LockIcon from "@mui/icons-material/Lock";

const Sidebar = () => {
  const { theme } = useContext(ThemeContext);
  const { sidebarOpen, setSidebarOpen } = useContext(DashboardLayoutContext);
  const { hasPermission } = useAdminAuth();

  // Un item de menu utilise directement le "path" (ex: "productManagement")
  // pour retrouver sa permission dans permissionsConfig.js
  const isPathAllowed = (path) => {
    const permission = getPermissionForRoute(path);
    return hasPermission(permission);
  };

  return (
    <>
      {/* Overlay mobile */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside
        className={`
          sidebar
          ${theme === "dark" ? "sidebar-dark" : "sidebar-light"}
          ${sidebarOpen ? "open" : ""}
        `}
      >
        <div className="sidebar-close-btn d-md-none">
          <IconButton onClick={() => setSidebarOpen(false)}>
            <CloseIcon sx={{ color: theme === "dark" ? "#fff" : "#1c1c1c" }} />
          </IconButton>
        </div>
        {/* Avatar */}
        <div className="text-center my-3">
          <Avatar
            src={img_profil}
            sx={{
              width: 100,
              height: 100,
              border: "2px solid #FA7F1B",
              margin: "auto",
            }}
          />
        </div>

        <hr />

        <ul className="nav nav-pills flex-column mb-auto">
          <div className="accordion accordion-flush" id="sidebarAccordion">
            {SidebarMenu.map((item, index) => {
              if (item.type === "accordion") {
                // Un groupe est considéré verrouillé seulement si TOUS ses enfants sont interdits
                const allChildrenLocked = item.children.every(
                  (child) => !isPathAllowed(child.path)
                );

                return (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${item.id}`}
                      >
                        <img
                          src={item.icon}
                          className="me-2 img"
                          alt={item.title}
                        />
                        {item.title}
                        {allChildrenLocked && (
                          <LockIcon
                            sx={{ fontSize: 14, marginLeft: "auto", opacity: 0.6 }}
                          />
                        )}
                      </button>
                    </h2>

                    <div
                      id={`collapse-${item.id}`}
                      className="accordion-collapse collapse"
                    >
                      <div className="accordion-body">
                        {item.children.map((child, i) => {
                          const allowed = isPathAllowed(child.path);

                          return allowed ? (
                            <NavLink
                              key={i}
                              to={child.path}
                              className="nav-link"
                              onClick={() => setSidebarOpen(false)}
                            >
                              <img
                                src={child.icon}
                                className="me-2 img"
                                alt={child.label}
                              />
                              {child.label}
                            </NavLink>
                          ) : (
                            <div
                              key={i}
                              className="nav-link nav-link-locked"
                              style={{ opacity: 0.5, cursor: "not-allowed" }}
                              title="Accès non autorisé"
                            >
                              <img
                                src={child.icon}
                                className="me-2 img"
                                alt={child.label}
                              />
                              {child.label}
                              <LockIcon
                                sx={{ fontSize: 14, marginLeft: "auto" }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              }

              const allowed = isPathAllowed(item.path);

              return (
                <li className="nav-item" key={index}>
                  {allowed ? (
                    <NavLink
                      to={item.path}
                      className="nav-link"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <img
                        src={item.icon}
                        className="me-2 img"
                        alt={item.label}
                      />
                      {item.label}
                    </NavLink>
                  ) : (
                    <div
                      className="nav-link nav-link-locked"
                      style={{ opacity: 0.5, cursor: "not-allowed" }}
                      title="Accès non autorisé"
                    >
                      <img
                        src={item.icon}
                        className="me-2 img"
                        alt={item.label}
                      />
                      {item.label}
                      <LockIcon sx={{ fontSize: 14, marginLeft: "auto" }} />
                    </div>
                  )}
                </li>
              );
            })}
          </div>
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;